
<template >
  <div style="background-color:#F7F7F7;padding-bottom:70px;" id="outermost">

        <van-nav-bar
            title="新建企业"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
            id="topbar"
        />
        <van-form @submit="onSubmit">
          <div class="topDiv">
              <van-cell-group>
                  <van-field label="企业名称" required v-model="companyInfo.companyName" input-align="right" placeholder="点击输入企业名称"
                  :rules="[{ required: true, message: '请输入企业名称' },{ validator: validateComapanyName, message: '企业名称重复' }]"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="行业" required readonly v-model="companyInfo.industryName" input-align="right" placeholder="点击选择行业"
                  :rules="[{ required: true, message: '请输入行业'}]" @click="showIndustryPicker = true"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="第二行业" readonly v-model="companyInfo.industry2Name" @click="showIndustry2Picker = true" input-align="right" placeholder="点击选择第二行业"/>
              </van-cell-group>
          </div>
          <div class="topDiv">
              <van-cell-group>
                  <van-field label="联系人1" required v-model="companyInfo.contacts1" maxlength="50" input-align="right" placeholder="点击输入联系人1"
                  :rules="[{ required: true, message: '请输入联系人1'}]"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="联系电话" required v-model="companyInfo.phone1" maxlength="11" input-align="right" placeholder="点击输入联系电话"
                  :rules="[{ required: true, message: '请输入联系电话'}]"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="联系人2" v-model="companyInfo.contacts2" maxlength="50" input-align="right" placeholder="点击输入联系人2"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="联系电话" v-model="companyInfo.phone2" maxlength="11" input-align="right" placeholder="点击输入联系电话"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="联系人3" v-model="companyInfo.contacts3" input-align="right" placeholder="点击输入联系人3"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="联系电话" v-model="companyInfo.phone3" input-align="right" placeholder="点击输入联系电话"/>
              </van-cell-group>
          </div>
          <div class="topDiv">
              <van-cell-group>
                  <van-field label="企业地址" type="textarea" maxlength="100" show-word-limit v-model="companyInfo.companyAddress" input-align="right" placeholder="点击输入企业地址"/>
              </van-cell-group>
          </div>
          <div class="topDiv">
              <van-cell-group>
                  <van-field label="排污许可证管理类别" readonly v-model="companyInfo.typeName" input-align="right" placeholder="点击选择排污许可证管理类别"
                  @click="loadManageType"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field name="radio" label="是否产生废气" input-align="right">
                    <template #input>
                      <van-radio-group v-model="companyInfo.wasteGas" direction="horizontal">
                        <van-radio name="0">否</van-radio>
                        <van-radio name="1">是</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="废气处理设施" v-model="companyInfo.gasTreatmentFacilities" maxlength="100" input-align="right" placeholder="点击输入废气处理设施"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field name="radio" label="是否产生废水" input-align="right">
                    <template #input>
                      <van-radio-group v-model="companyInfo.wasteWater" direction="horizontal">
                        <van-radio name="0">否</van-radio>
                        <van-radio name="1">是</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="废水处理设施" v-model="companyInfo.waterTreatmentFacilities" maxlength="100" input-align="right" placeholder="点击输入废水处理设施"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field name="radio" label="是否产生危废" input-align="right">
                    <template #input>
                      <van-radio-group v-model="companyInfo.hazardous" direction="horizontal">
                        <van-radio name="0">否</van-radio>
                        <van-radio name="1">是</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
              </van-cell-group>
          </div>
          <div style="position: fixed;bottom: 0px;width: 100%;">
              <van-button block color="#1B75F6" native-type="submit" v-if="!buttonLoading">完成提交</van-button>
              <van-button block color="#1B75F6" loading disabled v-if="buttonLoading">完成提交</van-button>
          </div>
        </van-form>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="pickerDict"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-popup v-model="showIndustryPicker" position="bottom" :lazy-render="false">
          <van-search
            v-model="codeName"
            placeholder="请输入行业代码或者名称"
            @blur="searchIndustryList"
            @search="searchIndustryList"
            shape="round"
            background="#F7F7F7"
          />

          <van-picker
            show-toolbar
            :columns="industryPickerDict"
            @confirm="onIndustryConfirm"
            @cancel="showIndustryPicker = false"
            ref="industrySearch"
          >
          </van-picker>
        </van-popup>
        <van-popup v-model="showIndustry2Picker" position="bottom" :lazy-render="false">
          <van-search
            v-model="codeName2"
            placeholder="请输入行业代码或者名称"
            @blur="searchIndustry2List"
            @search="searchIndustry2List"
            shape="round"
            background="#F7F7F7"
          />

          <van-picker
            show-toolbar
            :columns="industry2PickerDict"
            @confirm="onIndustry2Confirm"
            @cancel="showIndustry2Picker = false"
            ref="industry2Search"
          >
          </van-picker>
        </van-popup>
  </div>
</template>

<script>
    import $ from '@/fly'
    import { Toast } from 'vant';
    export default {
        name: 'project-addCompany',
        data () {
            return {
                companyInfo: {
                    companyName: '',
                    contacts1: '',
                    contacts2: '',
                    contacts3: '',
                    phone1: '',
                    phone2: '',
                    phone3: '',
                    industry: '',
                    industry2: '',
                    industryName: '',
                    industry2Name: '',
                    companyAddress: '',
                    pollutantManageType: '',
                    typeName: '',
                    wasteGas: '',
                    gasTreatmentFacilities: '',
                    wasteWater: '',
                    waterTreatmentFacilities: '',
                    hazardous: '',
                    projectId: ''
                },
                showPicker: false,
                pickerDict: [],
                manageTypeDict: [],
                showIndustryPicker: false,
                showIndustry2Picker: false,
                industryDict: [],
                industryPickerDict: [],
                codeName: '',
                industry2Dict: [],
                industry2PickerDict: [],
                codeName2: '',
                buttonLoading: false,
            }
        },
        methods: {
            loadManageType () {
                this.showPicker = true;
            },
            onConfirm (value) {
                var typeDict = this.manageTypeDict.filter(function (type) {
                    return type.name === value
                })
                var type = typeDict[0];
                this.companyInfo.pollutantManageType = type.code;
                this.companyInfo.typeName = type.name;
                this.showPicker = false;
            },
            onSubmit () {

                if(!this.buttonLoading){
                  this.buttonLoading = true
                  $.post('company/createByProject', this.companyInfo).then(res => {
                    Toast.success('新建成功！');
                    this.$router.go(-2);
                  }).catch(err => {
                    Toast.fail(err.message);
                  })
                }

            },
            onIndustryConfirm (value) {
                var typeDict = this.industryDict.filter(function (type) {
                    return type.name === value
                })
                var type = typeDict[0];
                this.companyInfo.industry = type.code;
                this.companyInfo.industryName = type.name;
                this.showIndustryPicker = false;
            },
            onIndustry2Confirm (value) {
                var typeDict = this.industry2Dict.filter(function (type) {
                    return type.name === value
                })
                var type = typeDict[0];
                this.companyInfo.industry2 = type.code;
                this.companyInfo.industry2Name = type.name;
                this.showIndustry2Picker = false;
            },
            getIndustryList () {
                // 加载行业下拉字典
                $.get('dict/getCodeNameDictByType', {
                    type: 'industry_code',
                    codeName: this.codeName
                }).then(res => {
                    this.industryDict = res;
                    this.industryDict.forEach(item => {
                        this.industryPickerDict.push(item.name);
                    })
                })
            },
            getIndustry2List () {
                // 加载第二行业下拉字典
                $.get('dict/getCodeNameDictByType', {
                    type: 'industry_code',
                    codeName: this.codeName2
                }).then(res => {
                    this.industry2Dict = res;
                    this.industry2Dict.forEach(item => {
                        this.industry2PickerDict.push(item.name);
                    })
                })
            },
            searchIndustryList () {
              $.get('dict/getCodeNameDictByTypeMobile', {
                type: 'industry_code',
                codeName: this.codeName
              }).then(res => {
                this.industryPickerDict = [];
                this.industryDict = res;
                this.industryDict.forEach(item => {
                  this.industryPickerDict.push(item.name);
                })
                this.$refs.industrySearch.setColumnValues(0, this.industryPickerDict);
              })
            },
            searchIndustry2List () {
              $.get('dict/getCodeNameDictByTypeMobile', {
                type: 'industry_code',
                codeName: this.codeName2
              }).then(res => {
                this.industry2PickerDict = [];
                this.industry2Dict = res;
                this.industry2Dict.forEach(item => {
                  this.industry2PickerDict.push(item.name);
                })
                this.$refs.industry2Search.setColumnValues(0, this.industry2PickerDict);
              })
            },
            validateComapanyName (val) {
                if (val) {
                    return new Promise((resolve) => {
                        $.get('company/checkCompanyName', {
                            companyName: val
                        }).then(res => {
                            resolve(!res > 0);
                        })
                    });
                }
            }
        },
        mounted () {
            // 加载排污许可证管理类别下拉字典
            $.get('dict/getDictByType/' + 'pollutantManageType').then(res => {
                this.manageTypeDict = res;
                this.manageTypeDict.forEach(item => {
                    this.pickerDict.push(item.name);
                })
            })

          var that = this
            // 加载行业下拉字典
          $.get('dict/getCodeNameByTypeMobile/HYML/HYXL').then(res => {
            this.industryDict = res;
            this.industryDict.forEach(item => {
              this.industryPickerDict.push(item.name);
            })
            var index = this.industryPickerDict.findIndex(function (data) {
              return data === that.companyInfo.industry + ' ' + that.companyInfo.industryName;
            })
            this.industryIndex = index;
          })

          // 加载第二行业下拉字典
          $.get('dict/getCodeNameByTypeMobile/HYML/HYXL').then(res => {
            this.industry2Dict = res;
            this.industry2Dict.forEach(item => {
              this.industry2PickerDict.push(item.name);
            })
            var index = this.industry2PickerDict.findIndex(function (data) {
              return data === that.companyInfo.industry2 + ' ' + that.companyInfo.industry2Name;
            })
            this.industry2Index = index;
          })

            this.companyInfo.wasteGas = '0';
            this.companyInfo.wasteWater = '0';
            this.companyInfo.hazardous = '0';
            this.companyInfo.projectId = localStorage.getItem('projectId');
        }
    }
</script>

<style lang="less" scoped>
    .topDiv{
        margin-top:20px;
    }
    .lableTxt{
        height:80px;
        line-height:80px;
        font-size:28px;
        width:28%;
    }
    .starTxt{
        height:80px;
        line-height:80px;
        font-size:28px;
    }
    .starTxt span{
        color: #FF6969;
        font-size: 30px;
        margin-right: 3px;
    }

    .typeDiv{
        padding:20px 30px;
        font-size: 28px;
    }
    .typeRow{
        padding-left:20px;
        border-left:6px solid #50C9FF;
    }
    .typeRow .van-col:nth-child(2){
        font-size: 0.38rem;
        font-weight: 400;
    }
    .typeItem{
        box-shadow: #f2f3f5 0px 0px 20px 1px;
    }
    .type-search {
        background-color: #EBEEF5;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 2vw 4vw;
        border-radius: 50px;
        padding:0 0 0 4vw;
    }
    .type-search button{
        border-radius: 0 50px 50px 0;
    }
    .search-icon {
      margin-left: 5px;
      font-size: 50px;
    }
    .searchInput {
      margin: 0 1.5vw;
      background-color: #F7F8FA;
      border: 0px;
      font-size: 14px;
      flex: 1;
      background:none;
      padding:15px;
    }
    .clear-icon {
        color: #999;
        font-size: 40px;
        margin-right:15px;
    }
    .van-cell{
        font-size: 0.37rem;
    }
    .van-radio{
        color: #666666;
    }
</style>
